/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Button } from '@mui/material';
import DeleteIcon from './supprimer.svg';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { columns, createData, handleDelete } from '../ecpHelper';

export default function TableElement(props: any) {
  const rows = createData(props.arr);
  const [list, setList] = useState(rows);

  useEffect(() => {
    setList(rows);
  }, [props.arr]);

  return (
    <>
      {list.length > 0 ? (
        <Paper style={{width: 'auto'}}>
          <TableContainer style={{maxHeight: '440'}}>
            <Table stickyHeader aria-label='sticky table'>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((row: any) => {
                  const date = (row.date)
                  return (
                    <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                      <TableCell>{row.source}</TableCell> 
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{date}</TableCell>
                      <TableCell>{row.value}</TableCell>
                      <TableCell align='center'>
                        <Button
                          variant='outlined'
                          onClick={() => handleDelete(row.id, props)}
                        >
                          <img src={DeleteIcon} alt='Supprimer' />
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        <Container className='error-message'>
          <Word value={'Aucune pompe paramétrée!!'} />
        </Container>
        
      )}
    </>
  );
}
